import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, EntityUIStore, StoreConfig } from '@datorama/akita';
import { ProjectUI } from './project-ui';
import { Project, ProjectUploadStatus } from './project.model';

export interface ProjectState extends EntityState<Project, number>, ActiveState<number> {
}

export interface ProjectUIState extends EntityState<ProjectUI> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'project'
})
export class ProjectStore extends EntityStore<ProjectState> {

  ui: EntityUIStore<ProjectUIState>;

  constructor() {
    super();

    const ui: ProjectUI = {
      uploadStatus: ProjectUploadStatus.Waiting,
      hasBuilding: false,
      disconnectedBuildings: [],

      hasVertexes: false,
      centralOffices: [],
      centralOfficeConnectedToBox: false,
      vertexesWithoutEdges: [],

      hasEdges: false,

      demographicAreas: {
        type: 'FeatureCollection',
        features: []
      }
    };

    this.createUIStore().setInitialEntityState(ui);
  }

}
